import React, { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import TFGRequest from "./TFGRequest/TFGRequest";
import TFGRequestsTable from "./TFGRequests/TFGRequestsTable";
import TFGDefense from "./TFGDefense/TFGDefense";
import TFGGrades from "./TFGGrades/TFGGrades";
import TFGTerms from "./TFGTerms";

const TFGAdmin = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_e, newValue) => {
    setTab(newValue);
  };

  return (
    <>
      <AppBar position="static">
        <Tabs variant="fullWidth" value={tab} onChange={handleTabChange}>
          <Tab label="Solicitudes" />
          <Tab label="Solicitudes de defensa" />
          <Tab label="Crear solicitud extraordinaria" />
          <Tab label="Convocatorias" />
          <Tab label="Subida de notas" />
        </Tabs>
      </AppBar>
      <div className="tfg">
        { tab === 0 && <TFGRequestsTable secr /> }
        { tab === 1 && <TFGDefense role="SECR" /> }
        { tab === 2 && <TFGRequest extraordinary onSuccess={() => setTab(1)} /> }
        { tab === 3 && <TFGTerms />}
        { tab === 4 && <TFGGrades /> }
      </div>
    </>
  )
}

export default TFGAdmin